import { httpsCallable } from "firebase/functions";
import { functions } from "../../../fb";

// Hintergrund-Versand für Quelp-Antworten (wie Quelp sendQueueStore): Der
// Agent macht sofort weiter, die Antwort geht im Hintergrund über quelpAction
// raus. Pills zeigen den Status (SendStatusPills.vue); Fehler bleiben stehen.
let counter = 0;

const state = {
  jobs: [], // { id, ticketId, orderUid, label, mode: 'send'|'close', status: 'sending'|'success'|'error', error }
};

const getters = {
  sendJobs: (s) => s.jobs,
  isTicketSending: (s) => (ticketId) => s.jobs.some((j) => j.ticketId === ticketId && j.status === "sending"),
};

const actions = {
  // payload = Daten für quelpAction (action reply|close + Felder). onDone(result) optional.
  async enqueueSend({ commit }, { ticketId, orderUid, label, mode, payload, onDone }) {
    const id = `job_${Date.now()}_${counter++}`;
    commit("addJob", { id, ticketId, orderUid: orderUid || null, label, mode, status: "sending", error: null });
    const run = async () => {
      try {
        const fn = httpsCallable(functions, "quelpAction", { timeout: 90000 });
        const res = await fn(payload);
        if (!res.data || res.data.status === "error") throw new Error((res.data && res.data.message) || "Senden fehlgeschlagen");
        commit("patchJob", { id, status: "success" });
        if (typeof onDone === "function") onDone(res.data);
        setTimeout(() => commit("removeJob", id), 2500);
      } catch (e) {
        commit("patchJob", { id, status: "error", error: e.message });
      }
    };
    run();
    return id;
  },
  dismissJob({ commit }, id) {
    commit("removeJob", id);
  },
};

const mutations = {
  addJob: (s, job) => s.jobs.push(job),
  patchJob: (s, patch) => {
    const idx = s.jobs.findIndex((j) => j.id === patch.id);
    if (idx !== -1) s.jobs.splice(idx, 1, { ...s.jobs[idx], ...patch });
  },
  removeJob: (s, id) => (s.jobs = s.jobs.filter((j) => j.id !== id)),
};

export default { state, getters, actions, mutations };
